import React, { useState, useRef, useEffect } from 'react';
import NavBar from '../../Components/Navbar/sidenav.tsx';
import Header from '../../Components/Header/header.tsx';
import Heading from '../../Components/Heading/heading.tsx';
import Dropdown from '../../Components/DropDown/drop-down.tsx';
import Newpagination from '../../Components/Pagination/pagination.tsx';
import EditVehicleModal from './edit-vehicle-modal.tsx';
import AddVehicleModal from './add-vehicle-modal.tsx';
import DocumentsModal from './documents-modal.tsx';
import '../../Components/Button/button-style.scss';
import StatusFilterTabs from '../../Components/Tab/tab.tsx';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { SelectChangeEvent } from '@mui/material/Select';
import { getVehicle, getWarehouseCompanyMapping } from '../Vehicles/action.ts';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import DescriptionIcon from '@mui/icons-material/Description'; 
import EditIcon from '@mui/icons-material/Edit';
import formatDate from '../../Utils/DateFormat/date-format.tsx';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button, TextField, Box, Typography, Tabs, Tab } from '@mui/material';
import * as XLSX from 'xlsx';
import QueryWidget from '../../Components/QueryWidget/query-widget.tsx';
import { saveAs } from 'file-saver';
interface VehiclesProps {   
}
const Vehicles: React.FC<VehiclesProps> = (props) => {
    const [pageSize, setPageSize] = useState<number>(10);
    const [page, setPage] = useState<number>(0);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [vehicleList, setVehicleList] = useState<any>();
    const [selectedVehicle, setSelectedVehicle] = useState<any>(null);
    const [warehouseOptions, setWarehouseOptions] = useState<{id: string, label: string}[]>([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState<{ id: string, name: string } | null>(null);
    const [searchTerm, setSearchTerm] = React.useState('');
    const [openModal, setOpenModal] = useState(false);
    const [refreshTable, setRefreshTable] = useState(false);
    const [documentsModal, setDocumentsModal] = useState(false);
    const [isAddVehicleOpen, setIsAddVehicleOpen] = useState(false);
    const [activeTab, setActiveTab] = useState<string>('Active');
const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(vehicleList.map(vehicle => ({
    'Sl No': (page * pageSize) + vehicleList.indexOf(vehicle) + 1,
    'Vehicle Number': vehicle?.number_plate,
    'Model': vehicle?.make_model,
    'Make Year': formatDate(vehicle?.reg_date),
    'Owner': vehicle?.owner_name,
    'Driver': vehicle?.driver_name,
    'Fuel Type':vehicle?.fuel_type,
    })));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Vehicles');
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'vehicles_list.xlsx');
};
 const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const userRole = userDetailsFromStorage?.role?.toLowerCase();
    const companiesId =  userDetailsFromStorage?.companies_id || ''
const updateField = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    if (!isNaN(Number(value))) {
        setPageSize(Number(value));
        setPage(0);
    }
};
const handleCloseModal = () => {
    setRefreshTable(prev => !prev);
    setOpenModal(false);
    setSelectedVehicle(null);
};
const handleClickOpen = () => {
    setIsAddVehicleOpen(true);
};
useEffect(() => {
    getVehicle(
    pageSize,
    page,
    (response: any) => {
        const vehicleDetails = response.message?.vehicles_list || [];
        setVehicleList(vehicleDetails);
        const totalVehiclesCount = response.message.total_vehicles_count;
        setTotalRecords(totalVehiclesCount);
    },
    (errMessage: any) => {
        toast.error(errMessage.message);
        setVehicleList('');
        setTotalRecords(0);
    },
        activeTab === 'Inactive' ? 0 : 1,
    '',
    selectedWarehouse?.name,
    );
  }, [page, pageSize, selectedWarehouse, refreshTable,activeTab]); 

useEffect(() => {
        getWarehouseCompanyMapping(
            companiesId,
            (response: any) => {
                const options = response.user_warehouses.map((warehouses: any) => ({
                    id: warehouses.warehouse.id,
                    label: warehouses.warehouse.name,
                }));
                setWarehouseOptions(options);
            },
            (errMessage: any) => {
                toast.error(errMessage.message);
            }
        );
}, [companiesId]);
const showEntries = [
    {id:'10',  label:'10'},
    { id: '20', label: '20' },
    { id: '50', label: '50' },
    { id: '100', label: '100' },
];
const handlePageClick = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage - 1);
};
const handleInputChange = (event) => {
    setSearchTerm(event.target.value);  
};
const handleSearchClick = () => {
    getVehicle(
        '',
        '',
        (response: any) => {
            const vehicleDetails = response.message?.vehicles_list || [];
            setVehicleList(vehicleDetails);
            const totalVehiclesCount = response.message.total_vehicles_count;
            setTotalRecords(totalVehiclesCount);
        },
        (errMessage: any) => {
            if(errMessage.message?.errors?.number_plate){
                toast.error(errMessage.message?.errors?.number_plate[0])
            }
            else
                {toast.error(errMessage.message);}
            setVehicleList('')
            setTotalRecords(0);
        },
        activeTab === 'Inactive' ? 0 : 1,
        searchTerm,
        selectedWarehouse?.name,
);
};
const handleCloseDetailsModal = () => {
    setDocumentsModal(false);
    setSelectedVehicle(null);
};
const handleDocumentsClick = (vehicle: any) => {
    setSelectedVehicle(vehicle);
    setDocumentsModal(true);
};
const handleEditClick = (vehicle: any) => {
    setSelectedVehicle(vehicle);
    setOpenModal(true);
};
const handleTabChange = (newTab: string) => {
    setActiveTab(newTab);
    setPage(0);
}
const columns: GridColDef[] = [
    { field: 'sl_no', headerName: 'Sl No', width: 100, headerAlign: 'center' },
    { field: 'vehicle_no', headerName: 'Vehicle Number', width: 165, headerAlign: 'center' },
    { field: 'driver', headerName: 'Driver', width: 200, headerAlign: 'center' },
    { field: 'owner', headerName: 'Owner', width: 200, headerAlign: 'center' },
    { field: 'model', headerName: 'Model', flex: 1, headerAlign: 'center' },
    { field: 'reg_date', headerName: 'Make Year', flex: 1, headerAlign: 'center' },
    { field: 'fuel_type', headerName: 'Fuel Type', width: 140, headerAlign: 'center' },
     {
        field: 'actions',
        headerName: 'Actions',
        width: 150, 
        headerAlign: 'center',
        renderCell: (params: GridRenderCellParams) => {
            return (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        gap: '8px',
                    }}
                >
                    <IconButton color="primary" onClick={() => handleDocumentsClick(params.row)}>
                        <DescriptionIcon /> 
                    </IconButton>
                  
                        <IconButton color="primary" onClick={() => handleEditClick(params.row)}>
                            <EditIcon />
                        </IconButton>
        
                </div>
            );
        },
    }
];

const handleCloseAddVehicle = () => {
    setRefreshTable(prev => !prev);
    setIsAddVehicleOpen(false);
};

const handleWarehouseChange = (event: SelectChangeEvent<string>) => {
    const warehouseId = event.target.value;
    const warehouse = warehouseOptions.find(c => c.id === warehouseId);
    const transformedWarehouse = warehouse ? { id: warehouse.id, name: warehouse.label } : null;
    setSelectedWarehouse(transformedWarehouse);
}
const rows = vehicleList ? vehicleList.map((vehicle, index) => (
    {
        id: vehicle.id,
        sl_no: (page * pageSize) + index + 1,
        vehicle_no: vehicle?.number_plate,
        model: vehicle?.make_model,
        reg_date: formatDate(vehicle?.reg_date),
        owner: vehicle?.owner_name,
        owner_phone: vehicle?.owner_phone,
        driver_phone: vehicle?.driver_phone,
        driver: vehicle?.driver_name,
        driver_id: vehicle?.driver_id,
        fuel_type: vehicle?.fuel_type,
    }
)) : [];

    return (
        <>   
            <Header/>
            <div style={{ marginTop: "70px" }}>
                <Heading
                    title="List Of Vehicles"
                    page='vehicles'
                    closeIcon="false"
                    leftContent={
                        <>
                            <Box display="flex" alignItems="center">
                                <Typography style={{ marginRight: '5px' }}>Show Entries:</Typography>
                                <Dropdown
                                    options={showEntries}
                                    selectedValue={pageSize.toString()}
                                    handleChange={(event) => updateField(event)}
                                    width="90px"
                                    height="50px"
                                />
                            </Box>
                            <Box sx={{ 
                                marginLeft: '10px', 
                                marginTop: {
                                    xs: '10px',
                                    sm: '10px',
                                    md: '10px',
                                    lg: '0px'
                                } 
                            }}>
                                <Dropdown
                                    options={warehouseOptions}
                                    selectedValue={selectedWarehouse?.id || ''}
                                    handleChange={(event) => handleWarehouseChange(event)}
                                    placeholder="Choose Warehouse"
                                    label={"Choose Warehouse"}
                                    width="190px"
                                    height="50px"
                                />
                            </Box>
                        </>
                    }
                    rightContent={
                        <>
                            <Box display="flex" alignItems="center" gap="10px">
                                <TextField
                                    className="styled-textfield"
                                    variant="outlined"
                                    size="small"
                                    value={searchTerm}
                                    onChange={handleInputChange}
                                    placeholder="Search by Vehicle Number"
                                />
                                <Button className="custom-button" onClick={handleSearchClick}>
                                    Search
                                </Button>
                            </Box>
                            <Box sx={{ 
                                marginTop: {
                                    xs: '10px', 
                                    sm: '0px',  
                                    md: '10px', 
                                    lg: '0px'
                                } 
                            }}>
                                <Button className="custom-button" onClick={handleClickOpen}>
                                    Add Vehicle
                                </Button>
                                <Button 
                                    className="custom-button" 
                                    sx={{ 
                                        marginLeft: {
                                            xs: '10px', 
                                            sm: '0px',  
                                            md: '10px'
                                        } 
                                    }} 
                                    onClick={exportToExcel}
                                >
                                    <DownloadIcon />
                                </Button>
                            </Box>
                        </>
                    }
                />
                <AddVehicleModal
                    addVehicleModalOpen={isAddVehicleOpen}
                    handleCloseAddVehicle={handleCloseAddVehicle}
                />
            </div>
                <Box sx={{  marginBottom: 2, marginLeft: { xs: '10px', sm: '180px' } }}>
                          <StatusFilterTabs 
                               tabs={['Active', 'Inactive']}
                               activeTab={activeTab} 
                               onTabChange={handleTabChange} 
                           />
                       </Box>

        <Box 
            className="table-container custom-data-grid" 
            sx={{ 
                marginLeft: {
                    xs: '10px', 
                    sm: '180px', 
                },
                marginTop: '10px', 
                marginRight: '40px', 
                position: 'relative', 
                height: '500px', 
                overflowY: 'auto' 
            }}
        >
            <DataGrid
                rows={rows}
                columns={columns}
                rowCount={totalRecords}
                autoHeight={false}
                disableRowSelectionOnClick
                disableColumnResize
                hideFooterPagination
                classes={{
                    columnHeader: 'red-header',
                }}
             />
        </Box>
        <div style={{ marginLeft: '50%', marginTop: '8px' }}> 
            <Newpagination
                rows={totalRecords}
                pageSize={pageSize}
                page={page}
                handlePageChange={handlePageClick}
            />
         </div>
               <NavBar selected='Vehicles' />
        <EditVehicleModal
            open={openModal}
            onClose={handleCloseModal}
            vehicle={selectedVehicle}
            tab={activeTab?.toLowerCase()}
        />
        <DocumentsModal
            open={documentsModal}
            onClose={handleCloseDetailsModal}
            vehicle={selectedVehicle}
        />
        <QueryWidget />
        
    </>
    );
};

export default Vehicles;